// extracted by mini-css-extract-plugin
module.exports = {"bottomBarContainer":"bottombar_bottomBarContainer__1zXBO","bottomBarWidth":"bottombar_bottomBarWidth__uiPkf"};